const driver = () => window.localStorage;

export function localStorageManager(KEY: string) {
    return {
        getItem: () => {
            let res = undefined;

            try {
                let savedData: any = driver().getItem(KEY);
                res = JSON.parse(savedData);
            } catch (e: any) {
                console.warn('localStorageManager getItem error');
            }

            return res;
        },
        setItem: (data: any) => {
            try {
                let dataToSave = JSON.stringify(data);
                driver().setItem(KEY, dataToSave);
            } catch (e: any) {
                console.warn('localStorageManager setItem error');
            }
        },
        removeItem: () => driver().removeItem(KEY),
    };
}
